<template>
    <v-fab-transition>
    <div v-show="active">
        <v-expand-x-transition>
        <v-card
                class=""
                width="350"
                v-show="stage<3"
                height="680"
                style="margin-top:40px;margin-left:40px;"
                :img="require('../assets/cd/can_2.png')"
                flat
        >
            <v-expand-transition>
                <v-img v-show="stage===1 || stage===2" contain height="256" width="256" :src="require('../assets/cd/banner_1.png')" style="left: 260px;">

                </v-img>
            </v-expand-transition>

            <v-expand-transition>
                <v-img v-show="stage===2" contain height="300" width="300" :src="require('../assets/cd/banner_2.png')" style="top: 200px;">

                </v-img>
            </v-expand-transition>

        </v-card>
        </v-expand-x-transition>
            <v-expand-transition>
            <v-card
                    class=""
                    width="350"
                    v-show="stage>3 && stage<6"
                    height="680"
                    style="margin-top:40px;margin-left:40px;"
                    :img="require('../assets/cd/can_naked.png')"
                    flat
            >
                <v-img contain height="113" width="160"  style="height: 113px; width: 160px;  position: absolute; top: 100px; left: 90px;z-index: 2;" :src="require('../assets/cd/cd_logo.png')">

                </v-img>
                <v-img contain height="113" width="160"  style="height: 113px; width: 160px; position: absolute; top: 500px; left: 90px;z-index: 1;" :src="require('../assets/cd/by_chat.png')">

                </v-img>
                <div style="width: 227px; height: 530px; position: absolute; top: 80px; left: 62px; overflow:hidden;">
                    <v-img v-for="(image, index) in images" :key=index contain height="180" width="180" :style="{'top':image.top,'left':image.left,'transform':image.rotate}" style="mix-blend-mode: hard-light;position:absolute;opacity: 0.8;" :src="image.src">

                    </v-img>
                    <v-img v-for="(image, index) in images" :key=(index+1)*1000 contain height="180" width="180" :style="{'top':image.top,'left':image.left,'transform':image.rotate}" style="position:absolute;opacity: 0.8;" :src="image.src">

                    </v-img>





                </div>




            </v-card>
            </v-expand-transition>


        <v-card
                v-if="images.length>0 && stage>3 && stage<6"
                class="mx-auto"
                max-width="244"
                outlined
                style="max-width: 244px; position: absolute; left: 350px; top: 100px;"
        >

            <v-card-text>
                <b>Ingredienser:</b> {{ingredient_list}}
            </v-card-text>

        </v-card>
        <v-expand-transition>
            <v-img v-show="stage===4" contain height="300" width="300" :src="require('../assets/cd/banner_4.png')" style="top: 180px; left: 200px;position:absolute;">

            </v-img>
        </v-expand-transition>
        <v-expand-transition>
        <v-card
                class="pulse_me"
                width="506"
                v-show="stage===7"
                height="341"
                style="margin-top:200px;margin-left:40px;"
                :img="require('../assets/cd/flak.png')"
                flat
        >



        </v-card>


        </v-expand-transition>
        <v-fab-transition>
            <v-img v-show="stage===7" contain height="300" width="300"  style="position: absolute; left: 250px; z-index: 2; top: -20px;" :src="require('../assets/cd/banner_6.png')">

            </v-img>
        </v-fab-transition>
    </div>
    </v-fab-transition>


</template>

<script>
    export default {
        name: "SponsCD",
        data() {
            return {
                active:false,
                stage:0,
                images:[


                ],
                votes:[],
                voters:[],
                winners:[],


            }
        },
        mounted:function(){
            let u=this.$route.query.u;
            this.$socket.emit('spons_listen_cd',u);

            /*let self=this;
            setTimeout(function(){
                self.stage=7
            },500)*/


        },

        computed: {
            ingredient_list:function(){
                let img_dict={};
                for(let i=0;i<this.images.length;i++){
                    if(!(this.images[i].name.toLowerCase() in img_dict)){
                        img_dict[this.images[i].name.toLowerCase()]=0
                    }
                    img_dict[this.images[i].name.toLowerCase()]+=1
                }
                let returnstring="";


                var items = Object.keys(img_dict).map(function(key) {
                    return [key, img_dict[key]];
                });

                items.sort(function(first, second) {
                    return second[1] - first[1];
                });



                items=items.slice(0, 15);
                for(let i=0;i<items.length;i++){
                    returnstring+=items[i][0].charAt(0).toUpperCase() + items[i][0].slice(1)+ ` (${((items[i][1]/this.images.length)*100).toFixed(0)}%), `;

                }


                returnstring=returnstring.slice(0, -2);


                return returnstring
            }
        },

        sockets: {


            show_cd:function(){
                this.resetAll();
                this.go();

            },
            vote:function([message,user,image]){
                if(!this.voters.includes(user)){
                    this.voters.push(user);
                }
                let left=Math.round(Math.random()*120)-40+"px";
                let top=30+Math.round(Math.random()*400)-50+"px";
                let sign=(Math.round(Math.random()*100)>50)? -1 :1;
                let rotate=`rotate(${sign*Math.round(Math.random()*45)}deg)`;
                this.images.push({
                    src:image,
                    name:message,
                    top:top,
                    left:left,
                    rotate:rotate
                })


            },
            connected:function(){
            }
        },
        methods:{
            resetAll:function(){
                this.stage=0;
                this.voters=[];
                this.images=[];
                this.active=false;
            },

            go:function(){
                let self=this;

                setTimeout(function(){
                    self.active=true;
                },500);

                setTimeout(function(){
                    self.stage=1;
                },1000);
                setTimeout(function(){
                    self.stage=2;
                },2500);
                setTimeout(function(){
                    self.stage=3;
                },7500);
                setTimeout(function(){
                    self.stage=4;
                },9000);
                setTimeout(function(){
                    self.stage=5;
                },13000);
                setTimeout(function(){
                    self.stage=6;
                },69000);
                setTimeout(function(){
                    self.stage=7;
                },69500)
                setTimeout(function(){
                    self.active=false;
                    self.$socket.emit('bye_spons_cd',[self.voters.length,self.images.length]);
                    self.resetAll();
                },75000)

            }


        }
    }
</script>

<style>
    iframe{
        width:100% !important;
        height:100% !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }
    @keyframes MOVE-BG {

        from {
            -webkit-transform: translateX(-200px);
            -moz-transform: translateX(-200px);
            -ms-transform: translateX(-200px);
            -o-transform: translateX(-200px);
            transform: translateX(-200px);

        }
        to {

            -webkit-transform: translateX(-350px);
            -moz-transform: translateX(-350px);
            -ms-transform: translateX(-350px);
            -o-transform: translateX(-350px);
            transform: translateX(-350px);

        }
    }
    .move_bg{
        animation-name: MOVE-BG;
        animation-duration: 30s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: 1;
        -webkit-animation-fill-mode: forwards;
    }

    .hidden {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s 2s, opacity 2s linear;
    }
    .visible {
        visibility: visible;
        opacity: 1;
    }

    .shake_me{
        animation: shake 0.3s;
    }

    @keyframes shake {
        0% { transform: translate(1px, 1px) rotate(0deg); }
        10% { transform: translate(-1px, -2px) rotate(-1deg); }
        20% { transform: translate(-3px, 0px) rotate(1deg); }
        30% { transform: translate(3px, 2px) rotate(0deg); }
        40% { transform: translate(1px, -1px) rotate(1deg); }
        50% { transform: translate(-1px, 2px) rotate(-1deg); }
        60% { transform: translate(-3px, 1px) rotate(0deg); }
        70% { transform: translate(3px, 1px) rotate(-1deg); }
        80% { transform: translate(-1px, -1px) rotate(1deg); }
        90% { transform: translate(1px, 2px) rotate(0deg); }
        100% { transform: translate(1px, -2px) rotate(-1deg); }
    }
    @keyframes pulse {
        0% {
            transform: scale(1, 1);
        }

        50% {
            transform: scale(1.05, 1.05);
        }

        100% {
            transform: scale(1, 1);
        }
    }

    .pulse_me {
        animation: pulse 3s ease-in-out infinite;
    }
</style>
